export const tvaTypes = {
    NON: 0,
    OUI: 1
}